module.exports = __webpack_public_path__ + "static/media/violet.6a8159cf.png";